import { Info } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { QUICK_CREATE } from "@/lib/modules";
import { useNavigate } from "react-router-dom";
import { CompanyFormDialog } from "@/components/crm/CompanyFormDialog";
import { LeadDialog } from "@/components/crm/LeadDialog";
import { OpportunityDialog } from "@/components/sales/OpportunityDialog";
import { NewQuoteDialog } from "@/components/sales/NewQuoteDialog";

import { ActivityDialog } from "@/components/activities/ActivityDialog";
import { InterventionDialog } from "@/components/interventions/InterventionDialog";
export const QuickCreateModal = ({ type, onClose }) => {
  const nav = useNavigate();
  if (type === "cliente") return <CompanyFormDialog open onOpenChange={(o) => !o && onClose()} onSaved={(id) => { onClose(); nav(`/clienti/${id}`); }} />;
  if (type === "lead") return <LeadDialog open onOpenChange={(o) => !o && onClose()} onSaved={() => { onClose(); nav("/lead"); }} />;
  if (type === "attivita") return <ActivityDialog open onOpenChange={(o) => !o && onClose()} onSaved={() => nav("/attivita")} />;
  if (type === "appuntamento") return <ActivityDialog open preset={{ type: "appuntamento" }} onOpenChange={(o) => !o && onClose()} onSaved={() => nav("/attivita")} />;
  if (type === "intervento") return <InterventionDialog open onOpenChange={(o) => !o && onClose()} onSaved={(id) => { onClose(); nav(`/interventi/${id}`); }} />;
  if (type === "opportunita") return <OpportunityDialog open onOpenChange={(o) => !o && onClose()} onSaved={(id) => { onClose(); nav(`/opportunita/${id}`); }} />;
  if (type === "offerta") return <NewQuoteDialog open onOpenChange={(o) => !o && onClose()} />;
  return <PhaseModal type={type} onClose={onClose} />;
};

const PhaseModal = ({ type, onClose }) => {
  const cfg = QUICK_CREATE.find((q) => q.key === type);
  return (
    <Dialog open={!!cfg} onOpenChange={(o) => !o && onClose()}>
      {cfg && (
        <DialogContent className="sm:max-w-lg" data-testid={`quick-create-modal-${cfg.key}`}>
          <DialogHeader>
            <DialogTitle className="font-display text-xl">{cfg.label}</DialogTitle>
            <DialogDescription>Struttura predisposta. Il salvataggio sarà attivato con il modulo dedicato.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            {cfg.fields.map((f) => (
              <div key={f.name} className="space-y-1.5">
                <Label htmlFor={`qc-${f.name}`} className="text-xs font-medium text-slate-600">{f.label}</Label>
                <Input id={`qc-${f.name}`} type={f.type} placeholder={f.placeholder} data-testid={`quick-create-field-${f.name}`} />
              </div>
            ))}
            <div className="flex gap-2 rounded-control border border-sky-200 bg-sky-50 p-3 text-xs text-sky-800" data-testid="quick-create-phase-notice">
              <Info className="mt-0.5 h-4 w-4 shrink-0" />
              Il workflow completo di creazione sarà disponibile nella Fase {cfg.phase}.
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={onClose} data-testid="quick-create-cancel-button">Chiudi</Button>
            <Button disabled data-testid="quick-create-save-button">Salva</Button>
          </DialogFooter>
        </DialogContent>
      )}
    </Dialog>
  );
};
